import { RestService, Rest } from '@abp/ng.core';
import { Injectable, inject } from '@angular/core';
import type { BioforestEnvironmentDto } from '../dtos/models';

@Injectable({
  providedIn: 'root',
})
export class BioforestService {
  private restService = inject(RestService);
  apiName = 'Default';
  

  getBioforestEnvironment = (config?: Partial<Rest.Config>) =>
    this.restService.request<any, BioforestEnvironmentDto>({
      method: 'GET',
      url: '/api/app/bioforest/bioforest-environment',
    },
    { apiName: this.apiName,...config });
}